import { Handshake } from 'lucide-react';
import AdminUserManagement from './AdminUserManagement';

export default function AdminPartners() {
  return (
    <AdminUserManagement
      role="partner"
      title="Partners"
      subtitle="Manage business partners"
      Icon={Handshake}
      emptyText="No partners found"
    />
  );
}
